module.exports = __webpack_public_path__ + "images/champagne-room-regular-a2dfec5c5e11d3022287fe0cdaa3febf.png";